<template>
    <header>
        <div class="h-100 mx-auto" style="max-width: 530px" v-if="!($route.query.topNav === '0' && $route.name === 'instruction')">
            <div class="menu">
                <div class="back">
                    <a @click.prevent="$router.push('/help/waterguru')" href="" id="back-btn" v-if="$route.path !== '/help/waterguru' && showBack">
                        <img src="../assets/img/chevron-back.png" alt="Back"
                             srcset="../assets/img/chevron-back@2x.png 2x, ../assets/img/chevron-back@3x.png 3x">
                    </a>
                </div>
                <div class="info-page">
                    <h1 class="mb-0 d-flex align-items-center">
                        <img src="../assets/img/tab-help-white.png" alt="Logo" class="mr-1">
                        {{ $route.meta.title }}
                    </h1>
                </div>
                <div class="hd-m" @click="menuOpen = !menuOpen" id="burger-btn">
                    <div class="burger">
                        <svg v-if="showMenu" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                             id="Capa_1" x="0px" y="0px" viewBox="0 0 344.339 344.339" style="enable-background:new 0 0 344.339 344.339;" xml:space="preserve">
                            <g>
                                <g>
                                    <g><rect y="46.06" width="344.339" height="29.52" fill="#FFFFFF"></rect></g>
                                    <g><rect y="156.506" width="344.339" height="29.52" fill="#FFFFFF"></rect></g>
                                    <g><rect y="268.748" width="344.339" height="29.531" fill="#FFFFFF"></rect></g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div v-if="showMenu" class="head-menu" :class="{'menu-opened': menuOpen}">
                    <ul>
                        <li @click="menuOpen = false">
                            <router-link to="/help/waterguru">View All</router-link>
                        </li>
                        <li @click="menuOpen = false">
                            <router-link to="/category/start">Getting Started</router-link>
                        </li>
                        <li @click="menuOpen = false">
                            <router-link to="/category/refill">Refilling</router-link>
                        </li>
                        <li @click="menuOpen = false" class="border-bottom-0">
                            <router-link to="/category/clean">Emptying & Cleaning</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Header',
    props: {
        showMenu: {
            type: Boolean,
            default: true
        },
        showBack: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            menuOpen: false
        }
    }
}
</script>

<style scoped>

    header {
        position: absolute;
        top: 0;
        width: 100%;
        height: 44px;
    }

    .info-page {
        margin-left: 25px;
    }

    .info-page h1 {
        text-align: center;
        font-size: 13pt;
        font-family: Nunito, sans-serif;
        font-weight: 700;
        color: #fff;
    }

    .back {
        height: 100%;
        line-height: 50px;
        cursor: pointer;
        width: 57px;
    }

    .back a {
        height: 100%;
        line-height: 44px;
        display: block;
        padding-left: 25px;
    }

    .head-menu {
        width: 300px;
        height: 1000px;
        position: absolute;
        right: -355px;
        top: 44px;
        background-color: #27374A;
        padding: 85px 0 0 33px;
        opacity: 0;
        visibility: hidden;
        transition: .6s;
    }

    .head-menu.menu-opened {
        opacity: 1;
        visibility: visible;
        right: 0;
    }

    .hd-m {
        display: flex;
        padding: 13px 25px;
    }

    .menu {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        top: 0;
        height: 44px;
        background-color: #0C527F;
        max-width: 530px;
        width: 100%;
        z-index: 100;
    }

    .menu li a {
        color: #fff;
        font-size: 22px;
        font-weight: 600;
    }

    .menu li {
        padding-bottom: 18px;
        padding-top: 18px;
        border-bottom: 0.25px solid #364557;
    }

    .burger {
        cursor: pointer;
        position: relative;
        z-index: 110;
        width: 24px;
        height: 24px;
    }

    .router-link-exact-active {
        color: #23B8DC !important;
    }
</style>
